
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#D3D7E1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.175 7.482a4.632 4.632 0 00-.364 1.805 4.617 4.617 0 001.359 3.28 4.624 4.624 0 003.278 1.357c.782 0 1.55-.197 2.23-.571l1.003 1.003-.735.735a.382.382 0 000 .54l.724.724c.15.149.391.149.54 0l.735-.735.672.673-1.088 1.088a.451.451 0 00-.09.508.354.354 0 00.072.104l1.226 1.225c.128.13.323.169.508.09a.354.354 0 00.103-.073l1.106-1.105.768.768c.128.13.323.169.508.09a.354.354 0 00.104-.072l1.242-1.243a.323.323 0 00.072-.104.454.454 0 00-.09-.508l-5.548-5.543a4.632 4.632 0 00.571-2.23 4.624 4.624 0 00-1.357-3.278 4.625 4.625 0 00-3.278-1.358A4.624 4.624 0 006.168 6.01c-.425.426-.76.921-.993 1.473zm4.273 4.104a2.285 2.285 0 01-1.626-.673 2.262 2.262 0 01-.671-1.626c0-.613.239-1.191.673-1.626a2.286 2.286 0 011.626-.673c.613 0 1.191.24 1.625.673.434.435.674 1.011.674 1.626 0 .614-.241 1.192-.675 1.626a2.285 2.285 0 01-1.626.673z","fill":"#282E3E"}})])
          )
        }
      }
    